export const SCHEDULE_CYCLES__GET_DETAILS = 'SCHEDULE_CYCLES__GET_DETAILS';
export const SCHEDULE_CYCLES__MUTATE_DETAILS = 'SCHEDULE_CYCLES__MUTATE_DETAILS';
